import { useTranslation } from '../../../i18n';
import DurationField from '../../../components/common/DurationField.jsx';

/**
 * مدت هر ویزیت — a practitioner's default visit length at this clinic.
 *
 * The chips-plus-«دلخواه» widget itself is DurationField, shared with the
 * services screen's «مدت هر جلسه»; this keeps the visit wording in one place.
 * Shared by the desktop drawer, the mobile sheet and onboarding.
 */
export default function VisitDurationField({ value, onChange, disabled, resetKey }) {
  const { t } = useTranslation();
  return (
    <DurationField
      value={value}
      onChange={onChange}
      disabled={disabled}
      resetKey={resetKey}
      label={t('doctors.fields.visitLengthLong')}
      hint={t('people.drawer.visitDurationHint')}
    />
  );
}
